import Hero from '@/shared/blocks/hero'
import Testimonial from '@/shared/blocks/testimonial'
import FeatureInteractive from '@/shared/blocks/feature-interactive'
import EpiserverForm from '@/shared/blocks/episerver-form'
import ScrollAnimator from '@/shared/scroll-animator'

/*
 global document
*/

const initCommon = () => {
  const testimonials = document.querySelectorAll('.testimonial-block')
  testimonials.forEach((item) => {
    new Testimonial().initSlider(
      item.querySelector('.testimonial-block__element'),
      item.querySelector('.testimonial-block__controls')
    )
  })

  const featureInteractiveSliders = document.querySelectorAll('.js-feature-interactive')
  featureInteractiveSliders.forEach((item) => {
    new FeatureInteractive(item.querySelector('.js-feature-interactive-slides')).initSlider()
  })

  new Hero()
  new ScrollAnimator()
  new EpiserverForm()
}

export {
  // eslint-disable-next-line import/prefer-default-export
  initCommon
}
